import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 8 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0 1.01246C4.71488e-07 0.11226 1.07659 -0.338563 1.70623 0.297975L4.80165 3.4273C6.93388 5.58289 8 6.66069 8 8C8 9.33932 6.93388 10.4171 4.80164 12.5727L1.70623 15.702C1.07659 16.3386 5.05568e-07 15.8877 4.76837e-07 14.9875C4.68284e-07 14.7196 0.105304 14.4625 0.292744 14.2731L3.38815 11.1437C4.49423 10.0255 5.17859 9.32762 5.61118 8.75443C6.00162 8.23709 6.00117 8.05648 6.00103 8.00276L6.00103 8L6.00103 7.99725C6.00117 7.94353 6.00162 7.76292 5.61118 7.24558C5.1786 6.67239 4.49423 5.97446 3.38816 4.85627L0.292743 1.72695C0.105303 1.53745 5.81901e-08 1.28044 0 1.01246Z" })
});
export default SvgArrowRight;
